document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.sqf-calculator-container')) {
        var sqf_calculator_container = document.querySelector('.sqf-calculator-container');
        var sqf_input = sqf_calculator_container.querySelector('input[data-sqf-per-product]');
        var sqf_per_product = sqf_input.getAttribute('data-sqf-per-product');
        var price_per_product = sqf_input.getAttribute('data-price-per-product');
        var additional_sqf_checkbox = sqf_calculator_container.querySelector('#additionalSqf');
        var sqf = 0;
        var sqf_product_quantity = 1;
        var additional_sqf_percentage = 0;
        
        sqf_input.addEventListener('input', function(e) {
            updateSqf();
            updateSqfDisplay();
        });
        
        if (additional_sqf_checkbox) {
            additional_sqf_checkbox.addEventListener('change', function(e) {
            if (this.checked) {
                additional_sqf_percentage = this.value / 100;
            } else {
                additional_sqf_percentage = 0;
            }
            
            updateSqf();
            updateSqfDisplay();
            });
        }
        
        var quantitySpinners = document.querySelectorAll('.spinner[data-quantity-down], .spinner[data-quantity-up]');
        console.log("QUANTITY SPINNERS: ", quantitySpinners)
        quantitySpinners.forEach(function(spinner) {
            spinner.addEventListener('click', function(e) {
            e.preventDefault();
            var increment = 0;
            if (this.hasAttribute('data-quantity-down')) {
                increment = -1;
            } else if (this.hasAttribute('data-quantity-up')) {
                increment = 1;
            }
            
            updateProductQuantity(increment);
            });
        });
    }
    
    function updateSqf() {
        sqf = parseFloat(sqf_input.value);
        
        if (additional_sqf_percentage > 0) {
            sqf += sqf * additional_sqf_percentage;
        }
        
        sqf_product_quantity = Math.ceil(sqf / sqf_per_product);
    }
    
    function updateSqfDisplay() {
        var sqf_quantity_container = document.querySelector('.sqf-quantity-container');
        if (isNaN(sqf)) {
            sqf_quantity_container.classList.add('hidden');
        } else {
            sqf_quantity_container.classList.remove('hidden');
            document.querySelector('[data-quantity-display]').textContent = sqf_product_quantity;
            document.querySelector('[data-sqf-display]').textContent = sqf_product_quantity * sqf_per_product;

            document.querySelector('[data-price]').textContent = Shopify.formatMoney(price_per_product * sqf_product_quantity, document.body.getAttribute('data-money-format'));
            document.querySelector('[data-product-form] input[name="quantity"]').value = sqf_product_quantity;
            document.querySelector('[data-product-form] input[name="quantity"]').dispatchEvent(new Event('change'));
        }
    }
    
    function updateProductQuantity(increment) {
        sqf_product_quantity += increment;
        if (sqf_product_quantity < 1) {
            sqf_product_quantity = 1;
        }
        updateSqfDisplay();
    }
});